{
  "$id": "wealthlane://forms/rsu-award/ui",
  "schema": "./rsu-award.model.json",
  "semanticId": "rsuAwardForm",
  "page": {
    "goBack": true
  },
  "wrapper": {
    "bordered": true
  },
  "layout": [
    {
      "rowId": "main",
      "fields": [
        {
          "scope": "#/properties/participantId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 250,
          "maxWidthPx": 350
        },
        {
          "scope": "#/properties/awardNumber",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/firstName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/middleName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/lastName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/isUnvestedAcquisition",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 280,
          "startNewRow": true
        },
        {
          "scope": "#/properties/grantId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 250
        },
        {
          "scope": "#/properties/planName",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/issuedUnits",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/fmvAtGrant",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/grantPrice",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 220,
          "startNewRow": true
        },
        {
          "scope": "#/properties/grantValue",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/grantIssueDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/vestingStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/vestingTemplateId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/settlementTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/poolId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/grantReason",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/notes",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 475
        },
        {
          "scope": "#/properties/isAccepted",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 220,
          "startNewRow": true
        },
        {
          "scope": "#/properties/acceptanceDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/awardAcceptanceDocumentInput",
          "minCols": 2,
          "maxCols": 3,
          "minWidthPx": 250,
          "maxWidthPx": 500
        }
      ]
    },
    {
      "rowId": "tax_settlement",
      "title": "Set Up Tax Settlement Method",
      "fields": [
        {
          "scope": "#/properties/settlementConfiguration/properties/windowStart",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 260
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/windowEnd",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 260
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/defaultSettlementTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 300
        },
        {
          "scope": "#/properties/settlementConfiguration/properties/settlementMethods",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 300
        }
      ]
    },
    {
      "rowId": "award_adjustment",
      "title": "Award Adjustment Parameter",
      "fields": [
        {
          "scope": "#/properties/methodType",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/asOfDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/residualDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/amortizationDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/cancelShareTypeId",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/targetCancelled",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 130,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/adjustmentReason",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    },
    {
      "type": "udf",
      "moduleId": 2,
      "actionId": "GET_UDF_FIELDS",
      "title": "Other Information"
    }
  ],
  "modes": {
    "create": {
      "addButton": {
        "label": "Issue another RSU Grant",
        "icon": "group_add",
        "fullWidth": true
      },
      "card": {
        "labelTemplate": "#{n}"
      }
    }
  },
  "modeOverrides": {
    "create": {
      "title": "Add RSU Awards"
    },
    "edit": {
      "title": "Edit RSU Award"
    }
  }
}
